export default __webpack_public_path__ + "static/media/01.3ad651c4.jpg";